import { DirectUpload } from "@rails/activestorage";

const DIRECT_UPLOAD_URL = "/rails/active_storage/direct_uploads";

export type DirectUploadResult = {
  signedId: string;
  filename: string;
  byteSize: number;
  contentType: string;
};

// ActiveStorage direct upload → resolves with the blob's signed id. Browser PUTs
// straight to the bucket, so the bucket CORS policy must allow this origin.
export function uploadFileToActiveStorage(
  file: File,
  onProgress?: (percent: number) => void,
): Promise<DirectUploadResult> {
  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, DIRECT_UPLOAD_URL, {
      directUploadWillStoreFileWithXHR(xhr: XMLHttpRequest) {
        xhr.upload.addEventListener("progress", (event: ProgressEvent) => {
          if (event.lengthComputable && onProgress) {
            onProgress(Math.round((event.loaded / event.total) * 100));
          }
        });
      },
    });

    upload.create((error, blob) => {
      if (error) {
        reject(error);
      } else {
        resolve({
          signedId: blob.signed_id,
          filename: blob.filename,
          byteSize: blob.byte_size,
          contentType: blob.content_type,
        });
      }
    });
  });
}
